import { useEffect, useRef, useState } from 'react';
// import { Link } from 'react-router-dom';
import { checkMember, checkPromo, fetchPriceByType, getBizdev, getCity, getClass, getMember, getProgram, getTeacher, getType, postRegister } from '../../../services/services';
import { readCheckoutPrefill, deserializeSchedulesFromPrefill } from '../../../utils/checkoutPrefill';
// import { KotaModel } from '../../../model/kotaModel';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from 'sweetalert2';
import { useSearchParams } from 'react-router-dom';

function CheckoutForm() {

  const [searchParams] = useSearchParams();
  const programName = searchParams.get('program');
  const meet = searchParams.get('meet');

  const decodedProgramName = programName
    ? decodeURIComponent(programName)
    : '-';

  const decodedMeet = meet
    ? decodeURIComponent(meet)
    : '-';

  const [_cityList, _setCityList] = useState([]);
  const [_teacherList, _setTeacherList] = useState([]);
  const [_learningType, _setLearningType] = useState([]);
  const [_program, _setProgram] = useState([]);
  const [_classMeet, _setClassMeet] = useState([]);
  const [_payment, _setPayment] = useState({});
  const [_bizdev, _setBizdev] = useState([]);
  const [_errors, _setErrors] = useState({});

  const [_statusPayment, _setStatusPayment] = useState('N');
  const [_student, _setStudent] = useState({ ambassador: null });

  const [_selectedCityId, _setSelectedCityId] = useState("");
  const [_selectedLearningType, _setSelectedLearningType] = useState("");
  const [_typeCourse, _setTypeCourse] = useState("");
  const [_selectedProgram, _setSelectedProgram] = useState("");
  const [_selectedClassMeet, _setSelectedClassMeet] = useState("");
  const [_selectedMeetObj, _setSelectedMeetObj] = useState(null);
  const [_selectedMeetWeekly, _setSelectedMeetWeekly] = useState("");
  const [_selectedBizdev, _setSelectedBizdev] = useState("");
  const [_inputEmail, _setInputEmail] = useState("");
  const [_statusDiskon, _setStatusDiskon] = useState("N");
  const [_inputFirstName, _setInputFirstName] = useState("");
  const [_inputLastName, _setInputLastName] = useState("");
  const [_inputPhone, _setInputPhone] = useState("");
  const [_inputAddress, _setInputAddress] = useState("");
  const [_duration, _setDuration] = useState("");
  const [_schedules, _setSchedules] = useState([{ day: null, time: null }]);
  const [_reasons, _setReasons] = useState("");
  const [_other, _setOther] = useState("");
  const [_ielts, _setIelts] = useState("");
  const [_memberStatus, _setMemberStatus] = useState("N");
  const [_inputPromoCode, _setInputPromoCode] = useState("");
  const [_inputReferalCode, _setInputReferalCode] = useState("");
  const [_promoType, _setPromoType] = useState("");
  const [_midtransPrice, _setMidtransPrice] = useState(0);

  // State for popup
  const [showTermsPopup, setShowTermsPopup] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);

  const [_selectedExamDepart, _setSelectedExamDepart] = useState(new Date());
  const [_isExamDepartTouched, _setIsExamDepartTouched] = useState(false);

  const skipClearFromCityRef = useRef(false);
  const prevProgramRef = useRef('');
  const prevTypeCourseRef = useRef(null);

  // Ambil data kota saat komponen dimuat
  const fetchCity = async () => {
    try {
      const data = await getCity();
      _setCityList(data); // sesuaikan dengan struktur JSON API
    } catch (error) {
      console.error('Gagal mengambil data kota:', error);
    }
  };

  // Ambil data teacher saat komponen dimuat
  const fetchTeacher = async () => {
    try {
      const data = await getTeacher();
      _setTeacherList(data); // sesuaikan dengan struktur JSON API
    } catch (error) {
      console.error('Gagal mengambil data kota:', error);
    }
  };

  // Ambil data teacher saat komponen dimuat
  const fetchBizdev = async () => {
    try {
      const data = await getBizdev();
      _setBizdev(data); // sesuaikan dengan struktur JSON API
    } catch (error) {
      console.error('Gagal mengambil data Bizdev:', error);
    }
  };

  // Show data pembelajaran (online/offline) saat kota di klik
  const fetchType = async () => {
    try {
      const data = await getType(_selectedCityId);
      _setLearningType(data); // sesuaikan dengan struktur JSON API
    } catch (error) {
      console.error('Gagal memuat data pembelajaran:', error);
    }
  };

  // Show data program saat tipe pembelajaran di klik
  const fetchProgram = async () => {
    try {
      const data = await getProgram(
        _selectedCityId,
        _selectedLearningType
      );
      _setProgram(data); // sesuaikan dengan struktur JSON API
    } catch (error) {
      console.error('Gagal memuat data pembelajaran:', error);
    }
  };

  // Show data jumlah pertemuan saat tipe pembelajaran di klik
  const fetchClass = async () => {
    try {
      const data = await getClass(
        _selectedCityId,
        _selectedLearningType,
        _selectedProgram
      );
      _setClassMeet(data); // sesuaikan dengan struktur JSON API
    } catch (error) {
      console.error('Gagal memuat data jumlah pertemuan:', error);
    }
  };

  const getPriceByType = async () => {
    try {
      const data = await fetchPriceByType({
        id_program: _selectedProgram,
        id_type: _selectedClassMeet,
        id_area: _selectedCityId,
        schedule: _selectedLearningType,
        non_member: _memberStatus,
      });
      _setMidtransPrice(data.fix_price);
      _setPayment(data);
    } catch (error) {
      console.error('Gagal memuat data jumlah pertemuan:', error);
    }
  }

  const handleEmail = async () => {
    if (!_inputEmail) {
      _setStatusDiskon("N");
      getPriceByType();
      return;
    }

    // Ambil data email saat user input email
    try {
      const memberData = await getMember(_inputEmail);

      const paymentData = await checkMember(
        _selectedProgram,
        _selectedClassMeet,
        _selectedCityId,
        _selectedLearningType,
        memberData,
        _statusPayment,
        _student
      );

      if (memberData.status_payment === "N") {
        _setMemberStatus("N");
        _setStatusDiskon("N");
        _setMidtransPrice(paymentData.fix_price);
      } else {
        _setMemberStatus("Y");
        _setStatusDiskon("Y");
        _setPromoType("Member");
        _setMidtransPrice(paymentData.fix_price);
      }

    } catch (error) {
      console.error('Gagal validasi member:', error);
    }
  };

  const handlePromo = async () => {
    if (!_inputPromoCode) {
      console.log('promo code kosong atau invalid')
      if (_memberStatus == 'Y') {
        console.log('user adalah member / sudah input email member, jadi pakai harga member')
        _setStatusDiskon("Y");
        _setPromoType("Member");
        _setMidtransPrice(_midtransPrice);
      } else {
        console.log('user bukanlah member / sudah input email tapi invalid member, jadi harga normal tanpa diskon')
        _setStatusDiskon("N");
        _setPromoType(null);
        getPriceByType();
      }
      return;
    }

    // kirim kode promo
    try {
      const data = await checkPromo(
        _selectedProgram,
        _selectedClassMeet,
        _selectedCityId,
        _selectedLearningType,
        _inputPromoCode
      );
      _setMidtransPrice(data.fix_price);
      _setStatusDiskon("Y");
      _setPromoType("Voucher");


    } catch (error) {
      console.error('Gagal validasi kode promo:', error);
    }
  };

  const handleReason = (e) => {
    _setReasons(e.target.value);
    if (e.target.value !== "Lainnya") {
      _setOther("");
    }
    if (e.target.value) clearError("reasons");
  };

  const validateForm = () => {
    const newErrors = {};

    // BASIC
    if (!_typeCourse) newErrors.classStatus = "Status kelas wajib dipilih.";
    if (!_selectedCityId) newErrors.cityId = "Kota wajib dipilih.";
    if (!_selectedLearningType) newErrors.learningType = "Tipe belajar wajib dipilih.";

    // TRIAL & REGULAR
    if (!_selectedBizdev) newErrors.selectedRecomender = "Recomender wajib dipilih.";
    if (!_inputFirstName) newErrors.firstName = "Nama depan wajib diisi.";
    if (!_inputLastName) newErrors.lastName = "Nama belakang wajib diisi.";

    if (!_inputPhone) {
      newErrors.phone = "Nomor HP / WhatsApp wajib diisi.";
    } else {
      const phoneDigits = _inputPhone.replace(/\D/g, "");
      if (phoneDigits.length < 10 || phoneDigits.length > 13) {
        newErrors.phone = "Nomor HP harus 10–13 digit.";
      }
    }

    if (!_inputEmail) {
      newErrors.email = "Email wajib diisi.";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(_inputEmail)) {
        newErrors.email = "Format email tidak valid.";
      }
    }

    if (!_inputAddress) newErrors.address = "Alamat lengkap wajib diisi.";

    // TRIAL CLASS
    if (_typeCourse === 't') {
      _setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }

    // REGULAR CLASS ADDITION
    if (!_selectedProgram) newErrors.program = "Program wajib dipilih.";
    if (!_selectedClassMeet) newErrors.classMeet = "Detail pertemuan wajib dipilih.";
    if (!_selectedMeetWeekly) newErrors.classMeetWeekly = "Jumlah pertemuan wajib dipilih.";
    if (!_duration) newErrors.duration = "Durasi pembelajaran wajib dipilih.";

    if (!_schedules || _schedules.length === 0) {
      newErrors.day = "Hari dan jam wajib dipilih.";
    } else {
      _schedules.forEach((schedule, index) => {
        if (!schedule.day) newErrors[`day-${index}`] = "Hari wajib dipilih.";
        if (!schedule.time) newErrors[`time-${index}`] = "Jam wajib dipilih.";
      });
    }

    if (!_reasons) {
      newErrors.reasons = "Alasan wajib dipilih.";
    } else if (_reasons === "Kuliah Keluar Negeri" && !_ielts) {
      newErrors.reasons = "Estimasi target IELTS wajib dipilih.";
    } else if (_reasons === "Lainnya" && !_other) {
      newErrors.reasons = "Alasan lainnya wajib ditulis.";
    }

    if (!_selectedExamDepart) {
      newErrors.examDepart = "Tanggal ujian / keberangkatan wajib dipilih.";
    }

    if (!_isExamDepartTouched) {
      newErrors.examDepart = "Silakan pilih tanggal ujian / keberangkatan.";
    }

    _setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearError = (field) => {
    _setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const formattedSchedules = _schedules.map((item) => {
    const day = item.day?.label || "-";
    const time = item.time
      ? item.time.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" })
      : "-";
    return `Day: ${day}, Time: ${time}`;
  }).join("\n");

  // Modified formHandle to show popup first
  const formHandle = () => {
    if (!validateForm()) return;
    setShowTermsPopup(true);
  }

  // Handler for the popup "Next" button
  const handleTermsNext = () => {
    if (!agreeTerms) {
      alert("Anda harus menyetujui syarat dan ketentuan terlebih dahulu.");
      return;
    }
    setShowTermsPopup(false);
    submitForm();
  };

  const handleExamDepart = (date) => {
    _setSelectedExamDepart(date);
    _setIsExamDepartTouched(true);
    _setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors.examDepart;
      return newErrors;
    });
  };

  const submitForm = async () => {
    try {

      //convert to timestamp  
      const exam_depart = _selectedExamDepart
        ? _selectedExamDepart.toISOString().slice(0, 10)
        : null;

      const data = await postRegister(
        _typeCourse,
        _inputFirstName,
        _inputLastName,
        _inputPhone,
        _inputEmail,
        _inputAddress,
        _selectedProgram,
        _selectedLearningType,
        _selectedClassMeet,
        _selectedMeetWeekly,
        _midtransPrice,
        _selectedCityId,
        _selectedBizdev,
        _inputPromoCode,
        _duration,
        formattedSchedules,
        _reasons,
        _other,
        _ielts,
        _inputReferalCode,
        _teacherList,
        exam_depart
      );
      if (_typeCourse === "t") {
        if (data?.status === 200) {
          Swal.fire({
            title: "Berhasil",
            text: "Berhasil daftar trial class",
            icon: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "#dc3545"
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload()
            }
          })
        } else {
          alert('Something wrong trial...');
        }
      } else {
        if (data?.status === 200 && data.data) {
          window.snap.pay(data.data, {
            onSuccess: function (result) {
              console.log('Payment success:', result);
              window.location.reload(false);
            },
            onPending: function (result) {
              console.log('Payment pending:', result);
              window.location.reload(false);
            },
            onError: function (result) {
              console.error('Payment error:', result);
            },
            onClose: function () {
              console.warn('customer closed the popup without finishing the payment');
            }
          })
        } else {
          alert('Something wrong regular...');
        }
      }
    } catch (error) {
      if (error?.status === 403) {
        alert('Harga tidak tersedia, pastikan kode promo atau referal kode yang kamu masukan sudah benar.');
      } else {
        alert('Opps Terjadi kesalahan...');
      }
    }
  };

  useEffect(() => {
    if (_selectedClassMeet) {
      getPriceByType();
    }
  }, [_selectedClassMeet]);

  useEffect(() => {
    const p = readCheckoutPrefill();
    if (!p) return;
    skipClearFromCityRef.current = true;
    if (p.typeCourse != null && p.typeCourse !== '') _setTypeCourse(p.typeCourse);
    if (p.cityId != null && p.cityId !== '') _setSelectedCityId(String(p.cityId));
    if (p.learningType != null) _setSelectedLearningType(p.learningType);
    if (p.programId != null && p.programId !== '') _setSelectedProgram(String(p.programId));
    if (p.classMeet != null && p.classMeet !== '') _setSelectedClassMeet(String(p.classMeet));
    if (p.classMeetWeekly != null) _setSelectedMeetWeekly(p.classMeetWeekly);
    if (p.duration != null) _setDuration(p.duration);
    if (p.schedules && p.schedules.length) {
      _setSchedules(deserializeSchedulesFromPrefill(p.schedules));
    }
    if (p.payment && typeof p.payment === 'object') {
      _setPayment(p.payment);
    }
    if (p.midtransPrice != null && p.midtransPrice !== '') {
      _setMidtransPrice(Number(p.midtransPrice));
    }
  }, []);

  useEffect(() => {
    fetchCity();
    fetchTeacher();
    fetchBizdev();
  }, []);

  useEffect(() => {
    if (_selectedCityId) {
      fetchType();
      if (skipClearFromCityRef.current) {
        skipClearFromCityRef.current = false;
      } else {
        _setSelectedLearningType('');
        _setSelectedProgram('');
        _setSelectedClassMeet('');
        _setSelectedMeetWeekly('');
        _setMidtransPrice(0);
      }
    }
  }, [_selectedCityId]);

  useEffect(() => {
    if (prevTypeCourseRef.current && prevTypeCourseRef.current !== _typeCourse) {
      _setSelectedLearningType('');
      _setSelectedCityId('');
      _setSelectedProgram('');
      _setSelectedClassMeet('');
      _setSelectedMeetWeekly('');
      _setInputEmail('');
      _setInputPromoCode('');
      _setInputReferalCode('');
      _setMidtransPrice(0);
      _setPayment({});
    }
    prevTypeCourseRef.current = _typeCourse || '';
  }, [_typeCourse]);

  useEffect(() => {
    if (_selectedLearningType) {
      fetchProgram();
    }
  }, [_selectedLearningType]);

  useEffect(() => {
    if (!_selectedProgram) return;
    fetchClass();
    if (prevProgramRef.current !== '' && prevProgramRef.current !== _selectedProgram) {
      _setSelectedClassMeet('');
      _setSelectedMeetWeekly('');
      _setInputEmail('');
      _setInputPromoCode('');
      _setInputReferalCode('');
      _setMidtransPrice(0);
    }
    prevProgramRef.current = _selectedProgram;
  }, [_selectedProgram]);

  useEffect(() => {
    const selectedObj = _classMeet.find(
      (item) => String(item.id_type) === String(_selectedClassMeet)
    );
    _setSelectedMeetObj(selectedObj || null);
  }, [_classMeet, _selectedClassMeet]);

  const isTrial = _typeCourse === 't';

  let normalPrice = isTrial ? 0 : _payment.price;
  let totalPrice = isTrial ? 0 : _midtransPrice;

  let rupiah = Intl.NumberFormat('id-ID');

  return (
    <section className="page-wrapper single ">
      <div className="container">
        <div className="row justify-content-center">

          <div className="col-md-6 col-xl-6">
            <div className="login-form">
              <div className="form-header">
                <h2 className="font-weight-bold mb-3">Daftar English Course Sekarang</h2>

                <div className="info">
                  <span>Konfirmasi Course Pilihanmu</span>
                </div>
              </div>

              <form className="login login-register-form " method="post">

                <div className="form-row">
                  <label>Recomender </label>
                  <select className="form-select" aria-label="Default select example"
                    name='recomender'
                    onChange={(e) => {
                      _setSelectedBizdev(e.target.value);
                      if (e.target.value) clearError("selectedRecomender");
                    }}
                    value={_selectedBizdev}
                  >
                    <option value="">Pilih Recomender</option>
                    {_bizdev.map((item, index) => (
                      <option key={index} value={item.code_konsultan}>{item.nama}</option>
                    ))}
                  </select>
                  {_errors.selectedRecomender && <p className="text-danger text-sm mt-1">{_errors.selectedRecomender}</p>}
                </div>
                <div className="form-row">
                  <label>First Name</label>
                  <input type="text" className="form-control" placeholder="Masukan First Name"
                    name='firstName'
                    value={_inputFirstName}
                    onChange={(e) => {
                      _setInputFirstName(e.target.value);
                      if (e.target.value) clearError("firstName");
                    }}
                  />
                  {_errors.firstName && <p className="text-danger text-sm mt-1">{_errors.firstName}</p>}
                </div>
                <div className="form-row">
                  <label>Last Name</label>
                  <input type="text" className="form-control" placeholder="Masukan Last Name"
                    name='lastName'
                    value={_inputLastName}
                    onChange={(e) => {
                      _setInputLastName(e.target.value)
                      if (e.target.value) clearError("lastName");
                    }}
                  />
                  {_errors.lastName && <p className="text-danger text-sm mt-1">{_errors.lastName}</p>}
                </div>
                <div className="form-row">
                  <label>Phone / Whatsapp</label>
                  <input type="number" className="form-control" placeholder="Masukan Nomor HP"
                    name='phone'
                    value={_inputPhone}
                    onChange={(e) => {
                      _setInputPhone(e.target.value);
                      if (e.target.value) clearError("phone");
                    }}
                  />
                  {_errors.phone && <p className="text-danger text-sm mt-1">{_errors.phone}</p>}
                </div>
                <div className="form-row">
                  <label>E-mail</label>
                  <input type="email" id='email' className="form-control" placeholder="Email"
                    name='email'
                    value={_inputEmail}
                    onChange={(e) => {
                      _setInputEmail(e.target.value);
                      if (e.target.value) clearError("email");
                    }}
                    onBlur={handleEmail}
                  />
                  {_errors.email && <p className="text-danger text-sm mt-1">{_errors.email}</p>}
                </div>
                <div className="form-row">
                  <label>Alamat Lengkap</label>
                  <textarea className="form-control" rows="3"
                    name='address'
                    value={_inputAddress}
                    onChange={(e) => {
                      _setInputAddress(e.target.value);
                      if (e.target.value) clearError("address");
                    }}
                  >
                  </textarea>
                  {_errors.address && <p className="text-danger text-sm mt-1">{_errors.address}</p>}
                </div>
                
                {!isTrial && (
                  <div>
                    <div className="form-row">
                      <label>Kode Promo</label>
                      <input type="text" className="form-control" placeholder="Kode Promo"
                        name='promo'
                        value={_inputPromoCode}
                        onChange={(e) => _setInputPromoCode(e.target.value)}
                        onBlur={handlePromo}
                      />
                    </div>
                    <div className="form-row">
                      <label>Kode Referal</label>
                      <input type="text" className="form-control" placeholder="Kode Referal"
                        name='referal'
                        value={_inputReferalCode}
                        onChange={(e) => _setInputReferalCode(e.target.value)}
                      />
                    </div>
                    <div className="form-row">
                      <label htmlFor='reasons'>Alasan kamu mengambil english class di NIEC Indonesia ? </label>
                      <select
                        name='reasons'
                        value={_reasons}
                        onChange={handleReason}
                        className="form-select"
                        id='reasons'
                      >
                        <option value="">Pilih Alasan</option>
                        <option value="Kuliah Keluar Negeri">Kuliah Keluar Negeri</option>
                        <option value="J1 Program USA">J1 Program USA</option>
                        <option value="Meningkatkan Kemampuan Bahasa Inggris Secara General">Meningkatkan Kemampuan Bahasa Inggris Secara General</option>
                        <option value="Lainnya">Lainnya</option>
                      </select>
                      {
                        _reasons === "Kuliah Keluar Negeri" && (
                          <select
                            name='ielts'
                            value={_ielts}
                            onChange={(e) => {
                              _setIelts(e.target.value);
                              if (e.target.value) clearError("reasons");
                            }}
                            className="form-select mt-2"
                            aria-label="Default select example"
                          >
                            <option value="5.5">Pilih Target Score IELTS</option>
                            <option value="5.5">5.5</option>
                            <option value="6">6</option>
                            <option value="6.5">6.5</option>
                            <option value="7">7</option>
                          </select>
                        )
                      }
                      {
                        _reasons === "Lainnya" && (
                          <input
                            type="text"
                            name='other'
                            value={_other}
                            onChange={(e) => {
                              _setOther(e.target.value);
                              if (e.target.value) clearError("reasons");
                            }}
                            className="form-control mt-2"
                            placeholder="Tulis alasan lainnya..."
                          />
                        )
                      }
                      {_errors.reasons && <p className="text-danger text-sm mt-1">{_errors.reasons}</p>}
                    </div>

                    <div className="form-row">
                      <label htmlFor='examDepart'>  tanggal ujian IELTS / keberangkatan ke luar negeri ? </label>
                      <span className='custom-icon-date'>
                        <DatePicker
                          showIcon
                          selected={_selectedExamDepart}
                          onChange={handleExamDepart}
                          minDate={new Date(Date.now() + 24 * 60 * 60 * 1000)}
                        />
                      </span>
                      {_errors.examDepart && <p className="text-danger text-sm mt-1">{_errors.examDepart}</p>}
                    </div>                    
                  </div>
                )}

                <div className="form-row">
                  <p>
                    <b>Note: </b>Head Acadmic akan menghubungi dalam waktu 1 x 24 jam dan kelas dapat di mulai paling cepat 3 x 24 setelah konfirmasi.
                  </p>
                </div>
              </form>
            </div>
          </div>

          <div className="col-md-6 col-xl-6">
            <div className='p-5 sticky-payment'>
              <div className="">
                <h2 className="font-weight-bold mb-3">Rincian Pesanan</h2>
                <table className="table ">
                  <tbody>
                    <tr>
                      <th scope="row">Nama</th>
                      <td>:</td>
                      <td>{_inputFirstName} {_inputLastName}</td>
                    </tr>
                    <tr>
                      <th scope="row">Program</th>
                      <td>:</td>
                      <td>{`${decodedProgramName} ${decodedMeet}`}</td>
                    </tr>
                    <tr>
                      <th scope="row">No. Telp</th>
                      <td>:</td>
                      <td>{_inputPhone}</td>
                    </tr>
                    <tr>
                      <th scope="row">Email</th>
                      <td>:</td>
                      <td>{_inputEmail}</td>
                    </tr>
                    <tr>
                      <th scope="row">Alamat</th>
                      <td>:</td>
                      <td>{_inputAddress}</td>
                    </tr>
                  </tbody>
                </table>
                <div className=''>
                  <p>
                    Setelah melakukan pembayaran, harap cek email yang telah terdaftar untuk pengecekan invoice serta konfirmasi pembayaran.
                  </p>
                  <span className='text-end'>
                    {
                      _statusDiskon === 'Y' && normalPrice && (
                        <h3 className='mb-2'>Diskon {_promoType} : Rp. <s>{rupiah.format(normalPrice)}</s></h3>
                      )
                    }
                    <h3>Harga : Rp. {rupiah.format(totalPrice)}</h3>
                  </span>
                </div>
                <div className="form-row d-flex justify-content-end">
                  <button type="button" onClick={formHandle} className='btn-main mt-4'>{isTrial ? 'Daftar' : 'Proses Pembayaran'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Terms and Conditions Popup */}
      {showTermsPopup && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              maxWidth: 700,
              width: "95%",
              padding: 32,
              boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
              position: "relative"
            }}
          >
            <h4 className="mb-3">Syarat dan Ketentuan</h4>
            <div style={{ maxHeight: 400, overflowY: "auto", marginBottom: 16 }}>
              <iframe
                src="https://superstudent-bucketcourse.s3.ap-southeast-1.amazonaws.com/resource/59/1758599235_file.pdf#toolbar=0"
                title="Syarat dan Ketentuan"
                width="100%"
                height="400px"
                style={{ border: "none" }}
              />
            </div>
            <div className="form-check mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="agreeTerms"
                checked={agreeTerms}
                onChange={e => setAgreeTerms(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="agreeTerms">
                Saya telah membaca dan menyetujui syarat dan ketentuan di atas
              </label>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                style={{ borderRadius: "8px" }}
                className="btn btn-secondary me-2"
                onClick={() => {
                  setShowTermsPopup(false);
                  setAgreeTerms(false);
                }}
              >
                Batal
              </button>
              <button
                type="button"
                className="btn btn-danger"
                style={{ borderRadius: "8px" }}
                onClick={handleTermsNext}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default CheckoutForm;